<ng-container *ngIf="vm$ | async as vm">
	<div class="grid grid-cols-5 border-b">
		<div class="col-start-1 col-span-4">
			<h3 class="mb-4 font-bold">{{ vm.capitalizedClientTypeText }}s</h3>
			<p class="mb-6 w-7/12">
				Please review the {{ vm.clientTypeText }} names provided by Teranet and
				either create a new {{ vm.clientTypeText }} for your matter or update
				the name of an existing {{ vm.clientTypeText }}.
			</p>
		</div>

		<div class="flex flex-1 gap-4 mr-18 col-start-1">
			<p>Name On Title</p>
			<div class="w-24">
				<img src="/assets/images/teranet-logo.jpg" />
			</div>
		</div>

		<div class="col-start-4 col-span-2 mb-4">
			Update Existing or Create New {{ vm.capitalizedClientTypeText }}s*
		</div>

		<div
			*ngFor="let action of vm.sellerActions; let i = index"
			class="grid grid-cols-5 col-start-1 col-span-5 mb-2"
		>
			<div
				class="flex gap-4 col-start-1 col-span-2 bg-grey-lightest rounded-lg border border-grey-veryLight p-2 mb-2"
			>
				<div class="w-24">
					<img src="/assets/images/teranet-logo.jpg" />
				</div>
				<p class="text-grey">
					{{ action.newValue }}
				</p>
			</div>

			<div class="col-start-4 col-span-2">
				<app-matter-user-select-or-search
					[title]="'Existing ' + vm.clientTypeText + 's on file'"
					[placeholder]="'Select ' + vm.capitalizedClientTypeText"
					[showMatterClientTypes]="showMatterClientTypes"
					[selectedId]="action.selected"
					[prefilledNewClient]="{ name: action.newValue }"
					(remove)="removeClientSelection(i)"
					(selectedCurrent)="setCurrentClient($event, i, action.newValue)"
					(selectedAddClient)="addClient($event, i)"
					(selectedCreateClient)="createClient($event, i)"
				>
				</app-matter-user-select-or-search>
			</div>
		</div>
	</div>
	<div class="mt-10">
		<h3 class="font-bold mb-4">
			{{ vm.isCondo ? 'Unit Information' : 'Parcel Information' }}
		</h3>

		<p class="mb-4">
			Please review the parcel information and customize as needed.
		</p>

		<div>
			<div class="my-4" *ngFor="let pin of vm.parentPins">
				<app-title-sync-form
					#titleSyncForm
					[showComparison]="vm.showComparisonMap[pin.pin]"
					[titleSearchPin]="pin"
					(onTitleUpdate)="onTitleSync(pin.pin, $event)"
				></app-title-sync-form>

				<hr class="mt-4" />
			</div>
		</div>
	</div>
</ng-container>
